import React from 'react';

const LinkConfigurationWrapper = (NativeComponent) => ({ adminConfig }) => {
  const { isEnabled, disableTextItem } = adminConfig.parameters;
  const { className = '', children } = NativeComponent.props;
  if (!isEnabled) {
    return (
      <a className={`${className} disabled`} data-content={disableTextItem}>
        {children}
      </a>
    );
  }
  return NativeComponent;
};

export default LinkConfigurationWrapper;
